import {
  InstrumentResource,
  OpenOrdersCommonParams,
  OrderManagementResource,
  useOpenOrdersCommon,
} from '@eih-netbroker/common';
import { useMemo } from 'react';
import { useAccounts } from './useAccounts';
import { useResource, useResourceHeaders } from './useResource';

export const useOpenOrders = () => {
  const orderManagementResource = useResource(OrderManagementResource);
  const instrumentResource = useResource(InstrumentResource);
  const { getResourceHeaderWithToken, getResourceHeaderForMultiAccount } = useResourceHeaders();
  const { selectedAccountOrClient, selectedClient } = useAccounts();

  const p = useMemo<OpenOrdersCommonParams>(
    () => ({
      selectedAccountOrClient,
      selectedClient,
      orderManagementResource,
      instrumentResource,
      getResourceHeaderWithToken,
      getResourceHeaderForMultiAccount,
    }),
    [
      selectedAccountOrClient,
      selectedClient,
      orderManagementResource,
      instrumentResource,
      getResourceHeaderWithToken,
      getResourceHeaderForMultiAccount,
    ],
  );

  return useOpenOrdersCommon(p);
};
